import { render } from "./QaEmailList.vue?vue&type=template&id=0c203986"
import script from "./QaEmailList.vue?vue&type=script&lang=js"
export * from "./QaEmailList.vue?vue&type=script&lang=js"

import "./QaEmailList.vue?vue&type=style&index=0&id=0c203986&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__